import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { handleNext, setCompletedState } from "../../actions/game.action";
import { GAME_COUNTRY } from "../../constants/gameTypes";
import RippleButton from "./RippleButton";

export const NextBonusButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const game = useSelector(({ game }) => game);
  const { selectedGame } = game;

  return (
    <div className="mt-4 flex w-full flex-col items-center justify-center gap-4 md:flex-row">
      {game[selectedGame.key].completed === false &&
        selectedGame.key !== GAME_COUNTRY && (
          <RippleButton
            className="flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border px-4 py-1 text-center font-semibold hover:bg-majky-200 hover:dark:bg-slate-500 md:w-fit"
            onClick={() => {
              dispatch(setCompletedState());
            }}
          >
            <span className="mr-2 inline-block">
              <img
                alt="🤷‍♀️"
                src="/images/1f937-200d-2640-fe0f.png"
                className="mt-0.05 mr-1.5 inline h-4 w-4 align-middle"
              />
            </span>
            {t("Give up")}
          </RippleButton>
        )}
      <RippleButton
        className={`text-md flex h-10 w-full items-center justify-center rounded-lg bg-majky-600 px-4 py-1 font-semibold text-white hover:bg-majky-700 active:bg-majky-700  md:w-fit`}
        onClick={() => {
          dispatch(handleNext());
        }}
      >
        <span className="mr-2 inline-block">
          <img
            alt="🎁"
            src="/images/1f381.png"
            className="mt-0.05 mr-1.5 inline h-4 w-4 align-middle"
          />
        </span>
        {selectedGame.key === "country"
          ? t("Bonus round")
          : t("Next bonus round")}
      </RippleButton>
    </div>
  );
};
